<template>
	<div style="height:100%">
		<!-- 订单内容区开始 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item v-if="queryList.role_lx==='1'" :to="{ path: '/cardList' }">明信片管理</el-breadcrumb-item>
			<el-breadcrumb-item>订单</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="top">
			<el-select v-if="queryList.role_lx==='1'" clearable v-model="queryList.area_id" @change="getList" filterable
					   placeholder="请选择需要查看的景区" style="width: 300px">
				<el-option v-for="v in scenicList" :key="v.area_id"
						   :label="v.area_name" :value="v.area_id">
				</el-option>
			</el-select>
			<el-button @click="statistics">订单统计</el-button>
		</div>
		<el-table :data="list" style="width: 100%">
			<el-table-column prop="id" label="ID" width="80"/>
			<el-table-column prop="nick_name_origin" label="用户"/>
			<el-table-column v-if="queryList.role_lx==='1'" prop="receive_user" label="收货人" width="100"/>
			<el-table-column prop="tel" label="手机号" width="110"/>
			<el-table-column v-if="queryList.role_lx==='1'" prop="tel" label="收货地址" min-width="200">
				<template slot-scope="scope">
					{{ scope.row.province }}{{ scope.row.county }}{{ scope.row.city }}{{ scope.row.address_detail }}
				</template>
			</el-table-column>
			<el-table-column prop="photo_num" label="照片数量" width="80"/>
			<el-table-column prop="total_fee" label="订单金额（元）" min-width="120"/>
			<el-table-column prop="my_money" label="分成（元）" min-width="95"/>
			<el-table-column prop="area_name" label="景区" min-width="150"/>
			<el-table-column v-if="queryList.role_lx==='1'" prop="ship_channel_name" label="物流公司" width="100"/>
			<el-table-column v-if="queryList.role_lx==='1'" prop="ship_sn" label="快递单号" width="170"/>
			<el-table-column prop="create_date" label="订单日期" width="160"/>
			<el-table-column label="操作" width="190" fixed="right" v-if="queryList.role_lx==='1'">
				<template slot-scope="scope">
					<el-button v-if="!scope.row.ship_sn" size="mini" @click="ship(scope.row)">发货</el-button>
					<el-button size="mini" type="primary" @click="getPicture(scope.row.id)">查看图片</el-button>
					<!--					<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>-->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
					   :current-page="queryList.pageindex"
					   :page-sizes="[10, 20, 30, 40]"
					   :page-size="queryList.pagesize"
					   layout="total,  prev, pager, next, jumper"
					   :total="total"
					   style="text-align:right;margin:0 16px 10px 0;border-radius:20px">
		</el-pagination>
		<el-dialog title="发货" :visible.sync="dialogExpress" width="500px">
			<el-form ref="express" :model="express" :rules="rules">
				<el-form-item label="快递公司：" prop="ship_channel">
					<el-select v-model="courierI" @change="changeExpress">
						<el-option v-for="(v,i) in couriers" :value="i" :label="v.name" :key="i"/>
					</el-select>
				</el-form-item>
				<el-form-item label="快递单号：" prop="ship_sn">
					<el-input style="width: 350px;" v-model="express.ship_sn"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogExpress = false">取 消</el-button>
				<el-button type="primary" @click="ok">确 定</el-button>
		    </span>
		</el-dialog>
		<el-dialog title="照片" :visible.sync="dialogImg" width="700px">
			<div class="list">
				<div class="opt" v-for="(v,i) in arrImg" :key="i">
					<img :src="v.photo_url" alt="">
					<div>
						<el-input ref="textarea" type="textarea" readonly :rows="5" v-model="v.back_word"
								  resize="none"></el-input>
						<div class="info">
							<el-tag type="warning">{{ v.photo_num }} 张</el-tag>
							<el-button type="primary" size="mini" @click="copy(i)">复制寄语</el-button>
							<el-button type="primary" size="mini" @click="download(i)">下载</el-button>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogImg = false">关 闭</el-button>
				<el-button type="primary" @click="downloadAll">下载全部</el-button>
		    </span>
		</el-dialog>
		<el-dialog title="统计" :visible.sync="dialogStatistics" width="600px">
			<div class="top">
				<el-select v-if="queryList.role_lx==='1'" clearable v-model="queryStatistics.area_id" @change="getStatistics" filterable
						   placeholder="请选择需要查看的景区" style="width: 300px">
					<el-option v-for="v in scenicList" :key="v.area_id"
							   :label="v.area_name" :value="v.area_id">
					</el-option>
				</el-select>
				<el-date-picker v-model="dateTime" type="daterange" range-separator="至" clearable @change="changeDate"
								start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<el-table :data="statisticsList" style="width: 100%">
				<el-table-column prop="photo_num" label="照片数量" width="80"/>
				<el-table-column prop="total_fee" label="订单金额（元）" width="120"/>
				<el-table-column prop="my_money" label="分成（元）" width="95"/>
				<el-table-column prop="area_name" label="景区" min-width="150"/>
			</el-table>
			<el-pagination background @size-change="changeSize1" @current-change="changeCurrent1"
						   :current-page="queryStatistics.pageindex"
						   :page-sizes="[10, 20, 30, 40]"
						   :page-size="queryStatistics.pagesize"
						   layout="total,  prev, pager, next, jumper"
						   :total="statisticsTotal"
						   style="text-align:right;margin:0 16px 10px 0;border-radius:20px">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogStatistics = false">关 闭</el-button>
		    </span>
		</el-dialog>
	</div>
</template>

<script>
import api from '../../api/card';
import qs from "qs";

let input_timer;
export default {
	data() {
		return {
			dialogExpress: false,
			dialogImg: false,//照片
			dialogStatistics: false,//统计
			express: {
				id: undefined,
				ship_sn: '',//快递编号
				ship_channel: 'SF',//快递公司编码
				ship_channel_name: '顺丰速运',//快递公司名称
			},
			trans: {
				Traces: []
			},
			total: 0,
			list: [],
			queryList: {
				area_id: '',
				pageindex: 1,
				pagesize: 10,
				count: true,
				role_lx: ''
			},
			courierI: 0,
			couriers: [{code: 'SF', name: '顺丰速运'}, {code: 'HTKY', name: '百世快递'}, {code: 'ZTO', name: '中通快递'},
				{code: 'STO', name: '申通快递'}, {code: 'YTO', name: '圆通速递'}, {code: 'YD', name: '韵达速递'},
				{code: 'YZPY', name: '邮政快递'}, {code: 'EMS', name: 'EMS'}, {code: 'HHTT', name: '天天快递'},
				{code: 'JD', name: '京东快递'}, {code: 'UC', name: '优速快递'}, {code: 'DBL', name: '德邦快递'},
				{code: 'ZJS', name: '宅急送'}],
			rules: {
				ship_sn: [{required: true, message: '请填写快递单号', trigger: 'blur'}]
			},
			arrImg: [],
			orderId: '',//orderId 下载文件名分类
			scenicList: [],
			queryStatistics: {
				role_lx: '',
				area_id: undefined,
				start_time: '',
				end_time: '',
				count: true,
				pageindex: 1,
				pagesize: 10,
			},
			statisticsTotal: 0,
			statisticsList: [],
			dateTime: ''
		};
	},
	mounted() {
		this.getScenic();
		let info = qs.parse(sessionStorage.getItem("userData"));
		this.queryList.role_lx = info.role_lx;
		this.queryList.area_id = info.area_id;
		this.queryStatistics.role_lx = info.role_lx;
		this.queryStatistics.area_id = info.area_id;
		this.getList();
		this.getStatistics();
	},
	filters: {
		state(type) {
			type = Number(type);
			let text;
			switch (type) {
				case 0:
					text = '暂无轨迹信息';
					break;
				case 1:
					text = '已揽收';
					break;
				case 2:
					text = '在途中';
					break;
				case 201:
					text = '到达派件城市';
					break;
				case 202:
					text = '派件中';
					break;
				case 211:
					text = '已放入快递柜或驿站';
					break;
				case 3:
					text = '已签收';
					break;
				case 301:
					text = '正常签收';
					break;
				case 302:
					text = '派件异常后最终签收';
					break;
				case 304:
					text = '代收签收';
					break;
				case 311:
					text = '快递柜或驿站签收';
					break;
				case 4:
					text = '问题件';
					break;
				case 401:
					text = '发货无信息';
					break;
				case 402:
					text = '超时未签收';
					break;
				case 403:
					text = '超时未更新';
					break;
				case 404:
					text = '拒收(退件)';
					break;
				case 405:
					text = '派件异常';
					break;
				case 406:
					text = '退货签收';
					break;
				case 407:
					text = '退货未签收';
					break;
				case 412:
					text = '快递柜或驿站超时未取';
					break;
			}
			return text;
		}
	},
	methods: {
		getList() {
			api.postcardOrderList(this.queryList).then(res => {
				this.list = res.list;
				this.total = res.totalcount;
			})
		},
		getScenic() {//所有景区
			api.scenicArea().then(res => {
				this.scenicList = res.list;
			})
		},
		getStatistics() {//统计
			api.postcardOrderCount(this.queryStatistics).then(res => {
				this.statisticsList = res.list;
				this.statisticsTotal = res.totalcount;
			})
		},
		searchOrders() {
			this.queryList.pageindex = 1;
			this.getList()
		},
		clearSharer() {
			this.queryList.pageindex = 1;
			this.getList();
		},
		ship(row) {//快递公司选择
			this.express.id = row.id;
			this.dialogExpress = true;
		},
		getPicture(order_id) {//订单图片
			this.dialogImg = true;
			this.orderId = order_id;
			api.postcardPhoto({order_id}).then(arrImg => {
				this.arrImg = arrImg;
			})
		},
		copy(i) {
			let textarea = this.$refs.textarea;
			textarea[i].select();
			document.execCommand('Copy');
		},
		down(url, filename) {
			function download(href, filename = '') {
				const a = document.createElement('a');
				a.download = filename;
				a.href = href;
				document.body.appendChild(a);
				a.click();
				a.remove();
			}

			fetch(url, {
				headers: new Headers({
					Origin: location.origin,
				}),
				mode: 'cors',
			}).then(res => res.blob()).then(blob => {
				const blobUrl = window.URL.createObjectURL(blob);
				download(blobUrl, filename);
				window.URL.revokeObjectURL(blobUrl);
			})
		},
		download(i) {
			this.down(this.arrImg[i].photo_url, `picture user${this.orderId} img${i + 1}`);
		},
		downloadAll() {
			this.arrImg.forEach((v, i) => {
				this.down(v.photo_url, `picture user${this.orderId} img${i + 1}`);
			})
		},
		changeExpress(i) {
			let courier = this.couriers[i];
			this.express.ship_channel = courier.code;
			this.express.ship_channel_name = courier.name;
		},
		ok() {
			this.$refs.express.validate(valid => {
				if (!valid) return false;
				api.addPostcardExpress(this.express).then(res => {
					this.$message({
						type: 'success',
						showClose: true,
						message: '录入成功!'
					});
					this.getList();
					this.dialogExpress = false;
				}).catch(err => {
					console.log(err)
					this.$message({
						type: 'error',
						message: err.msg || '录入失败！'
					});
				})
			})
		},
		del() {
			this.$confirm('确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				api.deletePostcard({id}).then(res => {
					this.$message({
						type: 'success',
						showClose: true,
						message: '删除成功!'
					});
				})
			})
		},
		statistics() {//统计
			this.dialogStatistics = true;
		},
		changeDate(val) {
			if (val != null) {
				this.queryStatistics.start_time = val[0];
				this.queryStatistics.end_time = val[1];
			} else {
				this.queryStatistics.start_time = '';
				this.queryStatistics.end_time = '';
			}
			this.getStatistics();
		},
		//分页
		handleSizeChange(val) {
			this.queryList.pagesize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.queryList.pageindex = val;
			this.getList();
		},
		//统计分页
		changeSize1(val) {
			this.queryStatistics.pagesize = val;
			this.getStatistics();
		},
		changeCurrent1(val) {
			this.queryStatistics.pageindex = val;
			this.getStatistics();
		},
	}
};
</script>

<style>
.top {
	display: flex;
	align-items: center;
	margin: 10px 0;
}

.search_input {
	width: 25em !important;
	margin-bottom: 1em;
}

.list {
	display: flex;
	flex-flow: column;
}

.list .opt {
	display: flex;
	margin: 10px 0;
}

.list .opt > div {
	flex: 1;
}

.list .opt > div .info {
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}

.list .opt textarea {
	font-size: 20px;
}

.list .opt img {
	max-width: 300px;
	max-height: 300px;
	margin-right: 10px;
}

.trans {
	font-size: 15px;
	line-height: 28px;
}

.trans .state {
	font-weight: 600;
	font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/card/order.vue